import {useState, useContext, useEffect, useCallback, useMemo} from "react";

import titanApiService from "./titan-api-service";
import stringHasValue from "../../../../utils/string-has-value";
import menuContext from "../../../global-layout/top-bar/menu-context";

/*
{
    id:"abcd1234ce",//some titan api image id
    mobileTarget:200,
    target:400,
    dimension:"width" //"height"
}
*/
const service = titanApiService();
const useTitanApi = ({
  id,
  mobileTarget,
  target,
  dimension
}) => {
  const {isMobile} = useContext(menuContext);

  const [sizes, setSizes] = useState([]);

  const load = useCallback(async () => {
    if (stringHasValue(id)) {
      try {
        const data = await service.getImageSizes(id);
        setSizes(data);
      } catch (e) {
        setSizes([]);
      }
    }
  },[id]);
  //because load is async, we can't just do useEffect(load,[load]);
  useEffect(() => {load()},[load]);

  const url = useMemo(() => {
    if (sizes.length === 0) {
      return ""
    }
    const simplified = sizes.map(rendition => {
      const size = parseInt(rendition[dimension]);
      const useLink = rendition.links.find(l => l.rel === "distribution") ??
        rendition.links.find(l => l.rel === "resource");
      const href = useLink?.href;
      return {
        size,
        href
      }
    }).sort((a,b) => a.size - b.size);

    const sizeThreshold = isMobile ? mobileTarget : target;
    const sizeCandidates = simplified.filter(r => r.size >= sizeThreshold);
    if (sizeCandidates.length === 0) {
      //none that are larger than our target so we either return an empty href or the href on the largets rendition we have
      return simplified.length === 0 ? "" :
        simplified[simplified.length - 1].href;
    } else {
      //candidates are sorted ascending, and we filtered to eliminate any lower than our target
      return sizeCandidates[0].href;
    }

  },[sizes, isMobile, mobileTarget, target, dimension])

  return url;

}

export default useTitanApi;
